/**
* @name: index
* @author: weiyong
* @date: 2024-06-16 21:01
* @description：index
* @update: 2024-06-16 21:01
*/
<template>
  <div class="xmTimeLine xmTimeLine-commonList">
    <col-show-list :cols="dataConfig.headerCols" :props="props" :record="record"/>
    <record-content class="record-content singleCtl"
                    @cardClick="cardClick"
                    :flowDealFlag="flowDealFlag"
                    :styles="props.contentConfigs&&props.contentConfigs.styles"
                    :dataConfig="dataConfig" :props="props&&props.contentConfigs&&props.contentConfigs.props" :record="record"/>
    <col-show-list :cols="dataConfig.bottomCols" :props="props" :record="record"/>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "index",
});
</script>

<script lang="ts" setup>
import ColShowList from "./coms/col-show-list.vue";
import RecordContent from "./coms/record-content.vue";

const propsPage=defineProps({
  flowDealFlag:{},
  dataConfig:{},
  props:{},
  record:{}
})
const {props}:any=toRefs(propsPage);

const emits=defineEmits(['cardClick'])
const cardClick=function (item){
  emits('cardClick',{item})
}
</script>

<style type="text/css" lang="less">

</style>
